function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { HAS_ACCESS, KEY_ENTER, KEY_SPACE, ORDER_SUBSCRIPTIONS_ENABLED, ROUTE_ORDER_SUBSCRIPTIONS, ROUTE_SEARCH, SEARCH_TYPE_ACTIVE, TRANSITION_TIMEOUT } from "@config/constants";
import { getDateAndTime } from "@common/services/helpers";
import ShowCategories from "./ShowCategories";
import ShowImage from "./ShowImage";
var Show = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Show, Component);
    var _super = _create_super(Show);
    function Show(props) {
        _class_call_check(this, Show);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showTabIndex: "0"
        };
        _this.show = null;
        _this.goToSearch = _this.goToSearch.bind(_assert_this_initialized(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Show, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.videoPlayerWrapper && this.props.videoPlayerWrapper.contains(this.show)) {
                    this.setState({
                        showTabIndex: "-1"
                    });
                }
            }
        },
        {
            /**
     * Navigate to search page with
     * query param set to the show's
     * title/
     */ key: "goToSearch",
            value: function goToSearch() {
                var _this_props = this.props, history = _this_props.history, show = _this_props.show, closePlayer = _this_props.closePlayer, videoPlayer = _this_props.videoPlayer, logo = _this_props.logo;
                if (logo && logo.access !== HAS_ACCESS && ORDER_SUBSCRIPTIONS_ENABLED) {
                    this.props.history.push(ROUTE_ORDER_SUBSCRIPTIONS);
                } else {
                    var quotedTitle = '"'.concat(show.title, '"');
                    var query = "?query=".concat(encodeURIComponent(quotedTitle), "&type=").concat(SEARCH_TYPE_ACTIVE);
                    var prevQuery = history.location.search;
                    if (prevQuery === query) {
                        return;
                    }
                    history && history.push("".concat(ROUTE_SEARCH).concat(query));
                    if (videoPlayer.isOpen) {
                        closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Triggers goToSearch method on enter or space keydown
     * @param event
     */ key: "handleKeyDown",
            value: function handleKeyDown(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.goToSearch(event);
                    event.stopPropagation();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                if (nextProps.isOpenEpgsList !== this.props.isOpenEpgsList) {
                    if (nextProps.isOpenEpgsList) {
                        this.setState({
                            showTabIndex: "0"
                        });
                        setTimeout(function() {
                            if (_this.show && _this.show.classList.contains("slick-current")) {
                                _this.show.focus();
                            }
                        }, TRANSITION_TIMEOUT);
                    } else {
                        this.setState({
                            showTabIndex: "-1"
                        });
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, className = _this_props.className, i18n = _this_props.i18n, showCategories = _this_props.showCategories, show = _this_props.show, isInPlayer = _this_props.isInPlayer, tabIndex = _this_props.tabIndex;
                var categoriesTemplate = showCategories ? /*#__PURE__*/ _jsx(ShowCategories, {
                    minorCategories: show["minor_categories"] || show.categories,
                    majorCategory: show["major_category"]
                }) : null;
                var tabIndexDynamic = this.show && !this.show.classList.contains("slick-active") ? this.state.showTabIndex : "-1";
                return /*#__PURE__*/ _jsx("div", {
                    ref: function(node) {
                        return _this.show = node;
                    },
                    tabIndex: tabIndex,
                    className: "".concat(className || "", " show"),
                    children: show ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(ShowImage, _object_spread({
                                tabIndexDynamic: tabIndexDynamic
                            }, this.props)),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "show-info",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "show-title",
                                        "data-tip": "".concat(i18n.common.searchChannel, ": ").concat(show.title),
                                        "data-for": isInPlayer ? "player-slider-tooltip" : "show-slider-tooltip",
                                        onKeyDown: this.handleKeyDown,
                                        tabIndex: isInPlayer ? tabIndexDynamic : "0",
                                        onClick: this.goToSearch,
                                        children: show.title
                                    }),
                                    categoriesTemplate,
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "date-time",
                                        dangerouslySetInnerHTML: getDateAndTime(show.start, show.stop, i18n.months)
                                    })
                                ]
                            })
                        ]
                    }) : null
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                // Returning `false` hugely improves the sliding experience
                // on mobile browsers. Before this fix the `render` method
                // was being called on every swipe. As long as this component
                // won't be updated dynamically this behaviour is OK.
                return nextState.showTabIndex !== this.state.showTabIndex || nextProps.currentWatchedEpg !== this.props.currentWatchedEpg || nextProps.logo !== this.props.logo;
            }
        }
    ]);
    return Show;
}(Component);
var mapStateToProps = function(param) {
    var videoPlayer = param.videoPlayer;
    return {
        videoPlayer: videoPlayer
    };
};
export default connect(mapStateToProps)(Show);
